/* unplugin-vue-components disabled */import { render } from "./119967_.vue?vue&type=template&id=81dfc7c0&scoped=true"
import script from "./119967_.vue?vue&type=script&lang=js"
export * from "./119967_.vue?vue&type=script&lang=js"

import "./119967_.vue?vue&type=style&index=0&id=81dfc7c0&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81dfc7c0"]])

export default __exports__